
      import Copy from './copy.vue'
      import type { App, Plugin } from 'vue'

      export const CopyPlugin: Plugin = {
        install(app: App) {
          app.component('Copy', Copy)
        },
      }
      export { Copy }
      